import { AgGridReact } from "ag-grid-react";
import { globalDefaultColDef } from "@/setup/ag-grid/mesf-theme";
import { useStandSetupTableData } from "../hooks/useStandSetupTableData";
import type { StandSetupGridRow } from "../models/MillSetupSheet";

export const StandSetupTable = ({ rows }: { rows: StandSetupGridRow[] }) => {
	const { columnDefs } = useStandSetupTableData();

	return (
		<div style={{ width: "100%", height: "100%" }}>
			<AgGridReact<StandSetupGridRow>
				rowData={rows}
				columnDefs={columnDefs}
				defaultColDef={globalDefaultColDef}
				getRowId={(params) => params.data.StandId?.toString() ?? ""}
				suppressContextMenu
				animateRows={false}
				rowHeight={36}
				headerHeight={36}
			/>
		</div>
	);
};
